import axios from 'axios';
import BaseUrl from '../../utils/api.js';

export default class LocationService {

    static getListResult(CompanyCode, list, ActionType) {

        var data={
            CompanyCode: CompanyCode,
            list: list,
            ActionType: ActionType
        }  
        return axios.post( BaseUrl+'Location', data);
    }

    static SaveLocation(CompanyCode, list, ActionType, email) {

        var data={
            CompanyCode: CompanyCode,
            list: list,
            ActionType: ActionType
        }  
        return axios.post( BaseUrl+'SaveLocation?email='+ email, data);
    }
}


// WEBPACK FOOTER //
// ./src/Services/LocationService/location.js